<section
  class="search-operations-container"
  [ngClass]="{ 'operations-column': orientation === 'column' }"
>
  <ng-container>
    <!-- Filter Button - mobile -->
    <ion-button
      class="sort-button-mobile"
      [ngClass]="
        total > 0 ? 'usf-fill-green-button' : 'usf-outline-green-button'
      "
      (click)="openFilterModal()"
      data-cy="open-search-filter-modal-button"
    >
      <ion-icon name="filter" data-cy="open-search-sort-modal-icon"> </ion-icon>
      <ng-container *ngIf="newSearchViewModel; else SortFilterLabel">
        {{ 'i18n.newSearch.searchResultOperationButtons.filter' | translate }}
      </ng-container>
      <ng-template #SortFilterLabel>
        {{ 'i18n.search.searchResultOperationButtons.filter' | translate }}
      </ng-template>

      <span *ngIf="total > 0">&nbsp;({{ total }})</span>
    </ion-button>
    <!-- Sort & Filter button - Tablet -->
    <ion-button
      class="sort-button-tablet"
      *ngIf="
        platformService?.platformType === platformService?.platformEnum.tablet
      "
      [ngClass]="
        total > 0 ? 'usf-fill-green-button' : 'usf-outline-green-button'
      "
      (click)="openFilterModal()"
      data-cy="open-search-sort-modal-button"
    >
      <ion-icon name="filter" data-cy="open-search-sort-modal-icon"> </ion-icon>
      <span data-cy="sort-and-filter-text">
        <ng-container *ngIf="newSearchViewModel; else SortFilterLabel">
          {{ 'i18n.newSearch.searchResultOperationButtons.filter' | translate }}
        </ng-container>
        <span *ngIf="total > 0"> ({{ total }})</span>
      </span>
    </ion-button>
    <ng-container
      *ngIf="
        sortConfiguration &&
        platformService?.platformType === platformService?.platformEnum.desktop
      "
    >
      <ion-button
        class="usf-outline-green-button sort-button-desktop"
        (click)="openFilterModal()"
        data-cy="open-search-sort-modal-button"
      >
        <span class="sort-label" data-cy="sort-by-text">
          {{
            'i18n.search.searchResultOperationButtons.sortBy' | translate
          }}&nbsp;
        </span>
        <span data-cy="sort-label-text">
          {{ sortConfiguration?.label }}
        </span>
      </ion-button>
    </ng-container>
  </ng-container>
  <!-- Hold for future implementation
    <ion-button
    [attr.disabled]="true"
    class="usf-outline-green-button tablet-desktop-button"
    [class.add-to-list-enabled]="mode === pageModes.addToListSearch"
  >
    {{
      'i18n.search.searchResultOperationButtons.compareSelections' | translate
    }}
  </ion-button> -->

  <ng-container *appShowSplit="[compareButtonFeatureFlag]">
    <ion-button
      *ngIf="showCompare"
      data-cy="compare-product-button"
      [ngClass]="
        compareButtonSelected
          ? 'usf-fill-green-button compare-button'
          : 'usf-outline-green-button compare-button'
      "
      (click)="handleCompareProducts()"
    >
      {{
        'i18n.search.searchResultOperationButtons.compareSelections' | translate
      }}
    </ion-button>
  </ng-container>

  <ion-button
    *ngIf="showAddToList && !isGuestUser"
    class="tablet-desktop-button"
    [ngClass]="
      addToListSelected ? 'usf-fill-green-button' : 'usf-outline-green-button'
    "
    (click)="handleAddToListClick()"
    data-cy="add-to-list-button"
  >
    {{ 'i18n.search.searchResultOperationButtons.addToList' | translate }}
  </ion-button>

  <ion-button
    *ngIf="showInventory"
    [ngClass]="
      addToInventorySelected
        ? 'usf-fill-green-button add-to-inventory-button'
        : 'usf-outline-green-button add-to-inventory-button'
    "
    (click)="handleAddToInventoryClick()"
    data-cy="add-to-inventory-button"
  >
    {{ 'i18n.search.searchResultOperationButtons.addToInventory' | translate }}
  </ion-button>

  <div
    class="toggle-filter-operation"
    *ngIf="
      showDeliveryToggle &&
      platformService?.platformType !== platformService?.platformEnum.tablet
    "
  >
    <app-search-toggle-filter> </app-search-toggle-filter>
  </div>
</section>
